import { render, staticRenderFns } from "./MigrationModule.vue?vue&type=template&id=0e8f5e78&scoped=true"
import script from "./MigrationModule.vue?vue&type=script&lang=js"
export * from "./MigrationModule.vue?vue&type=script&lang=js"
import style0 from "./MigrationModule.vue?vue&type=style&index=0&id=0e8f5e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8f5e78",
  null
  
)

export default component.exports